var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensorsOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_3310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 4.27C5.36 -0.0900002 12.46 -0.0900002 16.82 4.27M14.41 6.68C11.37 3.64 6.44 3.64 3.4 6.68M12.01 9.08C10.3 7.37 7.52 7.37 5.81 9.08M5.7 12.45H3.37C2.07 12.45 1 13.52 1 14.82C1 16.12 2.07 17.19 3.37 17.19H14.45C15.75 17.19 16.82 16.12 16.82 14.82C16.82 13.52 15.75 12.45 14.45 12.45H12.12",
    stroke: "#FF43AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47998 11.66C7.47998 10.8702 8.12021 10.23 8.90998 10.23C9.69975 10.23 10.34 10.8702 10.34 11.66C10.34 12.4498 9.69975 13.09 8.90998 13.09C8.12021 13.09 7.47998 12.4498 7.47998 11.66Z",
    fill: "#FF43AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_3310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.82,
    height: 18.19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorsOn);
export default __webpack_public_path__ + "static/media/sensorsOn.5b0474eb6cd655b67d8781380311ee29.svg";
export { ForwardRef as ReactComponent };